import { Link } from "react-router-dom";

export function SiteFooter() {
  return (
    <footer className="bg-surface-900 border-t border-surface-800/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        {/* Main footer content */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-12">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img src="/logo.svg" alt="TradeCraft" className="w-10 h-10" />
              <div>
                <span className="text-lg font-bold text-surface-100">TradeCraft</span>
                <p className="text-xs text-surface-500">by Colvix</p>
              </div>
            </div>
            <p className="text-surface-400 text-sm leading-relaxed mb-4">
              A platform for algorithmic strategy development and rule-based trading research.
            </p>
            <a
              href="https://www.colvix.net"
              target="_blank"
              rel="noopener noreferrer"
              className="opacity-70 hover:opacity-100 transition-opacity"
            >
              <img src="/colvix_footer_final.png" alt="Colvix" className="h-5" />
            </a>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-sm font-semibold text-surface-100 uppercase tracking-wider mb-4">Product</h4>
            <ul className="space-y-3">
              <li><Link to="/search" className="text-surface-400 hover:text-primary-400 transition-colors text-sm">Community Strategies</Link></li>
              <li><Link to="/backtest" className="text-surface-400 hover:text-primary-400 transition-colors text-sm">Backtest</Link></li>
              <li><Link to="/signup" className="text-surface-400 hover:text-primary-400 transition-colors text-sm">Create Account</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-sm font-semibold text-surface-100 uppercase tracking-wider mb-4">Legal</h4>
            <ul className="space-y-3">
              <li><Link to="/terms" className="text-surface-400 hover:text-primary-400 transition-colors text-sm">Terms of Service</Link></li>
              <li><Link to="/privacy" className="text-surface-400 hover:text-primary-400 transition-colors text-sm">Privacy Policy</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-surface-100 uppercase tracking-wider mb-4">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a href="mailto:support@colvix.net" className="text-surface-400 hover:text-primary-400 transition-colors text-sm">
                  support@colvix.net
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="border-t border-surface-800/50 pt-8 mb-8">
          <div className="space-y-3 text-xs text-surface-400 leading-relaxed">
            <p>
              <strong className="text-surface-200">Important Disclaimer:</strong> Colvix LLC provides TradeCraft as a platform for algorithmic strategy development and rule-based trading research.
              <strong className="text-surface-200"> We are not a broker, investment advisor, or fiduciary.</strong> Our platform is designed to help you make informed, independent investment decisions.
            </p>
            <p>
              All data, analyses, backtests, metrics, signals, and platform features are provided "AS-IS" without any warranties or guarantees.
              <strong className="text-surface-200"> Past performance is not indicative of future results.</strong> Investing involves risk, including the possible loss of principal.
              We do not guarantee performance and bear no responsibility for your trading activities or investment decisions.
            </p>
            <p>
              Trademarks and logos are the property of their respective owners and do not represent endorsements of any kind.
            </p>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-surface-400">
          <span>&copy; {new Date().getFullYear()} TradeCraft by Colvix LLC. All rights reserved.</span>
          <div className="flex items-center gap-4">
            <Link to="/terms" className="hover:text-surface-300 transition-colors">Terms</Link>
            <Link to="/privacy" className="hover:text-surface-300 transition-colors">Privacy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
